const AppRoutes = {
  OrderApp: "/aoa",
  OrderAppWL: "/aoa-wl",
  OrderWebWL: "/aow-wl",
};

export default AppRoutes;
